import * as React from "react";
import type { SVGProps } from "react";
const SvgCardNumber = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.4 18.3H4.8a2.4 2.4 0 0 1-2.4-2.4v-9a2.4 2.4 0 0 1 2.4-2.4h14.4a2.4 2.4 0 0 1 2.4 2.4v4.2M3 8.7h18m-2.4 10.8h1.525m0 0h1.418m-1.418 0v-5.564l-1.746 1.2"
    />
  </svg>
);
export default SvgCardNumber;
